import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { AppContextProvider } from "./context/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<AppContextProvider>
				<ErrorBoundary>
					<App />
				</ErrorBoundary>
			</AppContextProvider>
		</BrowserRouter>
	</React.StrictMode>
);
